import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Box, TextField, Typography, MenuItem } from '@mui/material'
import useTranslations from '../../../../i18n/useTranslations'
import { getFieldProps } from '../../../../common/formProps'
import useStyles from '../styles'
import Select from '../../../components/select'
import {
  CUSTOM_SELECT_REASON,
  CUSTOM_SELECT_TYPE,
} from '../../../../common/constants'
import TooltipButton from '../../../components/tooltipButton'

const InfoCustoms = ({
  id,
  values,
  destinCountryCode,
  originCountryCode,
  onChange,
  onBlur,
  fieldErrors,
  formErrors,
  touched,
}) => {
  const t = useTranslations()
  const classes = useStyles()
  const renderSender = () => {
    return (
      <>
        <Select
          label={t('shipping-send-form:customs:form:type')}
          name="senderType"
          id="senderType"
          defaultValue={
            id === 'sender' ? values.senderType : values.receptorType
          }
          className={clsx('input-medium', classes.marginInput)}
          value={values.senderType}
          onChange={onChange}
        >
          {CUSTOM_SELECT_TYPE.map(element => (
            <MenuItem key={element?.id} value={element?.id}>
              {t(element?.text)}
            </MenuItem>
          ))}
        </Select>
        {values.senderType === 'PERSONAL_NATIONAL' ? (
          <>
            <TextField
              name="senderInfo.dni"
              label={t('shipping-send-form:customs:form:dni')}
              InputLabelProps={{ required: true }}
              /////////////////////////////////
              error={touched?.wasSubmit && fieldErrors?.senderInfo?.dni}
              helperText={
                touched?.wasSubmit && fieldErrors?.senderInfo?.dni
                  ? t(fieldErrors?.senderInfo?.dni?.key)
                  : null
              }
              /////////////////////////////////
              {...getFieldProps(
                'senderInfo.dni',
                values,
                fieldErrors,
                touched,
                t,
              )}
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />

            <Select
              label={
                <>
                  {t('shipping-send-form:customs:form:reason')}
                  <TooltipButton
                    className={classes.tooltipInput}
                    type="primary"
                    title={t('tooltip:custom:reason')}
                    placement="right"
                  />
                </>
              }
              name="senderInfo.reason"
              id="senderInfo.reason"
              className={clsx('input-medium', classes.marginInput)}
              value={values.senderInfo.reason}
              onChange={onChange}
              isRequired={true}
            >
              {CUSTOM_SELECT_REASON.map(element => (
                <MenuItem key={element?.id} value={element?.id}>
                  {t(element?.text)}
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <>
            <TextField
              name="senderInfo.companyName"
              id="senderInfo.companyName"
              label={t('shipping-send-form:customs:form:company-name')}
              InputLabelProps={{ required: true }}
              {...getFieldProps(
                'senderInfo.companyName',
                values,
                fieldErrors,
                touched,
                t,
              )}
              error={touched?.wasSubmit && fieldErrors?.senderInfo?.companyName}
              helperText={
                touched?.wasSubmit && fieldErrors?.senderInfo?.companyName
                  ? t(fieldErrors?.senderInfo?.companyName?.key)
                  : null
              }
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />
            <TextField
              name="senderInfo.nifIva"
              id="senderInfo.nifIva"
              label={
                <>
                  {(destinCountryCode !== 'ES' && originCountryCode !=='ES') ? (
                    <>
                      {t('shipping-send-form:customs:form:prosecutor')}
                      <TooltipButton
                        className={classes.tooltipInput}
                        type="primary"
                        title={t('tooltip:custom:nif')}
                        placement="right"
                      />
                    </>
                  ) : (
                    t('shipping-send-form:customs:form:prosecutor-es')
                  )}
                </>
              }
              InputLabelProps={{ required: true }}
              {...getFieldProps(
                'senderInfo.nifIva',
                values,
                fieldErrors,
                touched,
                t,
              )}
              error={touched?.wasSubmit && fieldErrors?.senderInfo?.nifIva}
              helperText={
                touched?.wasSubmit && fieldErrors?.senderInfo?.nifIva
                  ? t(fieldErrors?.senderInfo?.nifIva?.key)
                  : null
              }
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />

            <Select
              label={
                <>
                  {t('shipping-send-form:customs:form:reason')}
                  <TooltipButton
                    className={classes.tooltipInput}
                    type="primary"
                    title={t('tooltip:custom:reason')}
                    placement="right"
                  />
                </>
              }
              name="senderInfo.reason"
              id="senderInfo.reason"
              className={'input-medium'}
              value={values.senderInfo.reason}
              onChange={onChange}
            >
              {CUSTOM_SELECT_REASON.map(element => (
                <MenuItem key={element?.id} value={element?.id}>
                  {t(element?.text)}
                </MenuItem>
              ))}
            </Select>
            <TextField
              name="senderInfo.bill"
              id="senderInfo.bill"
              label={t('shipping-send-form:customs:form:bill')}
              InputLabelProps={{ required: true }}
              {...getFieldProps(
                'senderInfo.bill',
                values,
                fieldErrors,
                touched,
                t,
              )}
              error={touched?.wasSubmit && fieldErrors?.senderInfo?.bill}
              helperText={
                touched?.wasSubmit && fieldErrors?.senderInfo?.bill
                  ? t(fieldErrors?.senderInfo?.bill?.key)
                  : null
              }
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />
          </>
        )}
      </>
    )
  }

  const renderReceptor = () => {
    return (
      <>
        <Select
          label={t('shipping-send-form:customs:form:type')}
          name="receptorType"
          id="receptorType"
          defaultValue={
            id === 'sender' ? values.senderType : values.receptorType
          }
          className={clsx('input-medium', classes.marginInput)}
          value={values.receptorType}
          onChange={onChange}
        >
          {CUSTOM_SELECT_TYPE.map(element => (
            <MenuItem key={element?.id} value={element?.id}>
              {t(element?.text)}
            </MenuItem>
          ))}
        </Select>
        {values.receptorType === 'PERSONAL_NATIONAL' ? (
          <TextField
            name="receptorInfo.dni"
            id="receptorInfo.dni"
            label={t('shipping-send-form:customs:form:dni')}
            InputLabelProps={{ required: true }}
            {...getFieldProps(
              'receptorInfo.dni',
              values,
              fieldErrors,
              touched,
              t,
            )}
            error={touched?.wasSubmit && fieldErrors?.receptorInfo?.dni}
            helperText={
              touched?.wasSubmit && fieldErrors?.receptorInfo?.dni
                ? t(fieldErrors?.receptorInfo?.dni?.key)
                : null
            }
            onChange={onChange}
            onBlur={onBlur}
            className={clsx('input-medium', classes.marginInput2)}
          />
        ) : (
          <>
            <TextField
              name="receptorInfo.companyName"
              id="receptorInfo.companyName"
              label={t('shipping-send-form:customs:form:company-name')}
              InputLabelProps={{ required: true }}
              {...getFieldProps(
                'receptorInfo.companyName',
                values,
                fieldErrors,
                touched,
                t,
              )}
              error={
                touched?.wasSubmit && fieldErrors?.receptorInfo?.companyName
              }
              helperText={
                touched?.wasSubmit && fieldErrors?.receptorInfo?.companyName
                  ? t(fieldErrors?.receptorInfo?.companyName?.key)
                  : null
              }
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />
            <TextField
              name="receptorInfo.nifIva"
              id="receptorInfo.nifIva"
              label={
                <>
                  {(destinCountryCode !== 'ES' && originCountryCode !=='ES') ? (
                    <>
                      {t('shipping-send-form:customs:form:prosecutor')}
                      <TooltipButton
                        className={classes.tooltipInput}
                        type="primary"
                        title={t('tooltip:custom:nif')}
                        placement="right"
                      />
                    </>
                  ) : (
                    t('shipping-send-form:customs:form:prosecutor-es')
                  )}
                </>
              }
              InputLabelProps={{ required: true }}
              {...getFieldProps(
                'receptorInfo.nifIva',
                values,
                fieldErrors,
                touched,
                t,
              )}
              error={touched?.wasSubmit && fieldErrors?.receptorInfo?.nifIva}
              helperText={
                touched?.wasSubmit && fieldErrors?.receptorInfo?.nifIva
                  ? t(fieldErrors?.receptorInfo?.nifIva?.key)
                  : null
              }
              onChange={onChange}
              onBlur={onBlur}
              className={clsx('input-medium', classes.marginInput2)}
            />
          </>
        )}
      </>
    )
  }

  return (
    <>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {id === 'sender'
          ? t('shipping-send-form:customs:sender-info')
          : t('shipping-send-form:customs:receptor-info')}
      </Typography>

      <Box component="section" className={classes.sectionColumn}>
        {id === 'sender' ? renderSender() : renderReceptor()}
      </Box>
    </>
  )
}

InfoCustoms.propTypes = {
  values: PropTypes.object,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
}

export default InfoCustoms
